import i18n from '@/plugins/i18n';

// GENDERS is function maded to translate text after changing lang.
// To use it in components type GENDERS()

export const MAIN_GENDERS = () => [
  {
    text: i18n.t('constants.genderTypes.male'),
    value: 'Male',
  },
  {
    text: i18n.t('constants.genderTypes.female'),
    value: 'Female',
  },
];

export const GENDERS = () => [
  ...MAIN_GENDERS(),
  {
    text: i18n.t('constants.genderTypes.other'),
    value: 'Other',
  },
  {
    text: i18n.t('constants.genderTypes.unidentified'),
    value: 'Unidentified',
  },
];

export const GENDERS_CSV = () => [
  {
    text: i18n.t('constants.genderTypes.male'),
    value: 'M',
  },
  {
    text: i18n.t('constants.genderTypes.female'),
    value: 'F',
  },
  {
    text: i18n.t('constants.genderTypes.other'),
    value: 'O',
  },
  {
    text: i18n.t('constants.genderTypes.unidentified'),
    value: 'U',
  },
];
